import { Component, OnInit } from '@angular/core';
import { PrintService } from '../print.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-print-appointments',
    templateUrl: './print-appointments.component.html',
    styleUrls: ['./print-appointments.component.scss'],
    standalone: false
})
export class PrintAppointmentsComponent implements OnInit {
  now:Date;
  type='day'
  startDate;
  docUID;
  code


  constructor(public print:PrintService,private route:ActivatedRoute) { 
    this.now=new Date();
  }

  ngOnInit(): void {
    this.type = this.route.snapshot.params.type;
    this.startDate = this.route.snapshot.params.startDate;
    this.docUID = this.route.snapshot.params.docUID;
    this.code = this.route.snapshot.params.code;
    let endDate = new Date(this.startDate);
     endDate.setHours(endDate.getHours() + 24);
     let endDateIso = endDate.toISOString();
     this.print.loadAppointments(this.type,this.startDate,endDateIso,this.docUID,this.code)
  }

}
